// import axios from "axios";
// import { myApi } from "../../../constants/consts";

// const api = axios.create({ baseURL: myApi, timeout: 15000 });

// const toNum = (v) => (v == null ? null : Number(v));

// // ⚠️ NAMED export olmalı — `export const adminService = {...}`
// // Default export (`export default`) DEĞİL!
// export const adminService = {
//   /* ─────────── COMPANIES (Sunucular) ─────────── */
//   async getCompanies() {
//     const { data } = await api.get("/get_all_companies");
//     return Array.isArray(data) ? data : [];
//   },

//   async addCompany(payload) {
//     const { data } = await api.post("/add_company", {
//       name: payload.name,
//       sunucu_kodu: payload.sunucuKodu,
//       tc: payload.tc || "",
//       vergi_no: payload.vergiNo || "",
//       contract: payload.contract || "no",
//       email: payload.email || "",
//       phone: payload.phone || "",
//     });
//     return data;
//   },

//   async editCompany(payload) {
//     const { data } = await api.post("/edit_company", {
//       id: payload.id,
//       name: payload.name,
//       sunucu_kodu: payload.sunucuKodu,
//       tc: payload.tc || "",
//       vergi_no: payload.vergiNo || "",
//       contract: payload.contract || "no",
//       email: payload.email || "",
//       phone: payload.phone || "",
//     });
//     return data;
//   },

//   async deleteCompany(id) {
//     const { data } = await api.post("/delete_company", null, {
//       params: { id },
//     });
//     return data;
//   },

//   /* ─────────── EDU (Eğitim) ─────────── */
//   /* ─────────── EDU (Eğitim) ─────────── */
//   async getEdus() {
//     const { data } = await api.get("/get_all_edus");
//     return Array.isArray(data) ? data : [];
//   },

//   async addEdu({ title, sunucuKodu, supporter, eduDate, duration, desc }) {
//     const { data } = await api.post("/add_edu", {
//       title,
//       sunucuKodu,
//       supporter,
//       eduDate,
//       duration,
//       desc,
//     });
//     return data;
//   },

//   async editEdu(
//     eduId,
//     { title, sunucuKodu, supporter, eduDate, duration, desc },
//   ) {
//     const { data } = await api.post(`/edit_edu/${eduId}`, {
//       title,
//       sunucuKodu,
//       supporter,
//       eduDate,
//       duration,
//       desc,
//     });
//     return data;
//   },

//   async deleteEdu(eduId) {
//     const { data } = await api.delete(`/delete_edu/${eduId}`);
//     return data;
//   },

//   /* ─────────── KULLANICILAR ─────────── */
//   async getUsersByType({ type, sunucuKodu = "" }) {
//     const { data } = await api.get("/get_users_by_type", {
//       params: { type, sunucu: sunucuKodu },
//     });
//     return Array.isArray(data) ? data : [];
//   },

//   /* ─────────── İÇ ORTAK ─────────── */
//   async changeUpdateValue({ target, newValue, userId, root = "support" }) {
//     const { data } = await api.post("/change_status_update_value", {
//       target,
//       new_value: newValue,
//       user_id: toNum(userId) ?? userId,
//       root,
//     });
//     return data;
//   },
//   /* ─────────── SUPPORTS (Destek Talepleri) ─────────── */
//   async getSupports() {
//     const { data } = await api.get("/get_all_supports");
//     return Array.isArray(data) ? data : [];
//   },

//   async createSupport({ title, userId, sunucuKodu, personel }) {
//     // Flutter: POST /create_support (201 dönüyor)
//     const { data } = await api.post("/create_support", {
//       user_id: userId,
//       title,
//       status: "Gönderildi",
//       sunucu_kodu: sunucuKodu,
//       supporter: personel,
//     });
//     // Bildirim flag'leri
//     await this.changeUpdateValue({
//       target: "nortek",
//       newValue: true,
//       userId: "all",
//       root: "support",
//     }).catch(() => {});
//     return data;
//   },

//   async updateSupport({ supportId, userId, title, sunucuKodu, personel }) {
//     const { data } = await api.post("/update_support", {
//       supportId,
//       user_id: userId,
//       title,
//       status: "Gönderildi",
//       sunucu_kodu: sunucuKodu,
//       supporter: personel,
//     });
//     await this.changeUpdateValue({
//       target: "nortek",
//       newValue: true,
//       userId: "all",
//       root: "support",
//     }).catch(() => {});
//     return data;
//   },

//   async deleteSupport(id) {
//     const { data } = await api.post("/delete_support", null, {
//       params: { id },
//     });
//     return data;
//   },
//   /* ─────────── USERS (Kullanıcılar) ─────────── */
//   async getUsersByType({ type, sunucuKodu = "" }) {
//     const { data } = await api.get("/get_users_by_type", {
//       params: { type, sunucu: sunucuKodu },
//     });
//     return Array.isArray(data) ? data : [];
//   },

//   async addUser({ username, phone, pass, email, sunucuKodu, type }) {
//     const { data } = await api.post("/signup", {
//       username,
//       phone,
//       pass,
//       email,
//       sunucu_kodu: type !== "destek" && type !== "admin" ? sunucuKodu : "",
//       type,
//     });
//     return data;
//   },

//   async editUser({ id, username, phone, pass, email, sunucuKodu, type }) {
//     const { data } = await api.post("/update_user_data", {
//       id,
//       username,
//       phone,
//       pass,
//       email,
//       sunucu_kodu: type !== "destek" && type !== "admin" ? sunucuKodu : "",
//       type,
//     });
//     return data;
//   },

//   async deleteUser(id) {
//     const { data } = await api.post("/delete_user", null, {
//       params: { id },
//     });
//     return data;
//   },

//   /* ─────────── KNOWLEDGE (Bilgi Bankası) ─────────── */
//   async getKnowledge() {
//     const { data } = await api.get("/get_Information");
//     return Array.isArray(data) ? data : [];
//   },

//   async addKnowledge({ title, description, image }) {
//     const { data } = await api.post("/add_knowledge", {
//       title,
//       description,
//       image,
//     });
//     return data;
//   },

//   async editKnowledge({ id, title, description, image }) {
//     const { data } = await api.post("/edit_knowledge", {
//       id,
//       title,
//       description,
//       image,
//     });
//     return data;
//   },

//   async deleteKnowledge(id) {
//     const { data } = await api.post("/delete_knowledge", null, {
//       params: { id },
//     });
//     return data;
//   },

//   async uploadFile(file, sunucuKodu = "BilgiBankasi", dosyaType = "image") {
//     const formData = new FormData();
//     formData.append("myfile", file);
//     formData.append("sunucukodu", sunucuKodu);
//     formData.append("dosyaType", dosyaType);
//     const { data } = await api.post("/upload", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//       timeout: 30000,
//     });
//     return data;
//   },
// };
import axios from "axios";
import { myApi } from "../../../constants/consts";

const api = axios.create({ baseURL: myApi, timeout: 15000 });

const toNum = (v) => (v == null ? null : Number(v));

// Sunucu / kullanıcı listeleri birçok sayfada (filtre dropdown'ları vb.) tekrar tekrar
// çekiliyordu. Kısa ömürlü önbellek + aynı anda gelen isteklerin birleştirilmesi.
// Ekleme/düzenleme/silme işlemlerinde önbellek temizlenir; { force: true } her zaman taze veri çeker.
const LIST_CACHE_TTL_MS = 30 * 1000;
const listCache = new Map(); // key -> { ts, promise }

const cachedList = (key, fetcher, force) => {
  const hit = listCache.get(key);
  if (!force && hit && Date.now() - hit.ts < LIST_CACHE_TTL_MS) {
    return hit.promise.then((arr) => arr.slice());
  }
  const promise = fetcher();
  listCache.set(key, { ts: Date.now(), promise });
  promise.catch(() => {
    if (listCache.get(key)?.promise === promise) listCache.delete(key);
  });
  return promise.then((arr) => arr.slice());
};

const invalidateLists = (prefix) => {
  for (const k of listCache.keys())
    if (k.startsWith(prefix)) listCache.delete(k);
};

export const adminService = {
  /* ═══════════════════════════════════════════════
     COMPANIES (Sunucular)
     ═══════════════════════════════════════════════ */
  async getCompanies({ force = false } = {}) {
    return cachedList(
      "companies",
      async () => {
        const { data } = await api.get("/get_all_companies");
        return Array.isArray(data) ? data : [];
      },
      force,
    );
  },

  async addCompany(payload) {
    const { data } = await api.post("/add_company", {
      name: payload.name,
      sunucu_kodu: payload.sunucuKodu,
      tc: payload.tc || "",
      vergi_no: payload.vergiNo || "",
      contract: payload.contract || "no",
      email: payload.email || "",
      phone: payload.phone || "",
    });
    invalidateLists("companies");
    return data;
  },

  async editCompany(payload) {
    const { data } = await api.post("/edit_company", {
      id: payload.id,
      name: payload.name,
      sunucu_kodu: payload.sunucuKodu,
      tc: payload.tc || "",
      vergi_no: payload.vergiNo || "",
      contract: payload.contract || "no",
      email: payload.email || "",
      phone: payload.phone || "",
    });
    invalidateLists("companies");
    return data;
  },

  async deleteCompany(id) {
    const { data } = await api.post("/delete_company", null, {
      params: { id },
    });
    invalidateLists("companies");
    return data;
  },

  /* ═══════════════════════════════════════════════
     EDU (Eğitim)
     ═══════════════════════════════════════════════ */
  async getEdus() {
    const { data } = await api.get("/get_all_edus");
    return Array.isArray(data) ? data : [];
  },

  async addEdu({ title, sunucuKodu, supporter, eduDate, duration, desc }) {
    const { data } = await api.post("/add_edu", {
      title,
      sunucuKodu,
      supporter,
      eduDate,
      duration,
      desc,
    });
    return data;
  },

  async editEdu(
    eduId,
    { title, sunucuKodu, supporter, eduDate, duration, desc },
  ) {
    const { data } = await api.post(`/edit_edu/${eduId}`, {
      title,
      sunucuKodu,
      supporter,
      eduDate,
      duration,
      desc,
    });
    return data;
  },

  async deleteEdu(eduId) {
    const { data } = await api.delete(`/delete_edu/${eduId}`);
    return data;
  },

  /* ═══════════════════════════════════════════════
     SUPPORTS (Destek Talepleri)
     ═══════════════════════════════════════════════ */
  async getSupports() {
    const { data } = await api.get("/get_all_supports");

    // data.forEach((element) => {
    //   if (element.id === 5012) {
    //     console.log(element);
    //   }
    // });

    return Array.isArray(data) ? data : [];
  },

  async createSupport({ title, userId, sunucuKodu, personel }) {
    const { data } = await api.post("/create_support", {
      user_id: userId,
      title,
      status: "Gönderildi",
      sunucu_kodu: sunucuKodu,
      supporter: personel,
    });
    // Bildirim flag'i — destekçilere yeni talep geldi
    await this.changeUpdateValue({
      target: "nortek",
      newValue: true,
      userId: "all",
      root: "support",
    }).catch(() => {});
    return data;
  },

  async updateSupport({ supportId, userId, title, sunucuKodu, personel }) {
    const { data } = await api.post("/update_support", {
      supportId,
      user_id: userId,
      title,
      status: "Gönderildi",
      sunucu_kodu: sunucuKodu,
      supporter: personel,
    });
    await this.changeUpdateValue({
      target: "nortek",
      newValue: true,
      userId: "all",
      root: "support",
    }).catch(() => {});
    return data;
  },

  async deleteSupport(id) {
    const { data } = await api.post("/delete_support", null, {
      params: { id },
    });
    return data;
  },

  /* ═══════════════════════════════════════════════
     USERS (Kullanıcılar)
     ═══════════════════════════════════════════════ */
  async getUsersByType({ type, sunucuKodu = "", force = false }) {
    return cachedList(
      `users:${type}:${sunucuKodu}`,
      async () => {
        const { data } = await api.get("/get_users_by_type", {
          params: { type, sunucu: sunucuKodu },
        });
        return Array.isArray(data) ? data : [];
      },
      force,
    );
  },

  async addUser({ username, phone, pass, email, sunucuKodu, type }) {
    const { data } = await api.post("/signup", {
      username,
      phone,
      pass,
      email,
      sunucu_kodu: type !== "destek" && type !== "admin" ? sunucuKodu : "",
      type,
    });
    invalidateLists("users:");
    return data;
  },

  async editUser({ id, username, phone, pass, email, sunucuKodu, type }) {
    const { data } = await api.post("/update_user_data", {
      id,
      username,
      phone,
      pass,
      email,
      sunucu_kodu: type !== "destek" && type !== "admin" ? sunucuKodu : "",
      type,
    });
    invalidateLists("users:");
    return data;
  },

  async deleteUser(id) {
    const { data } = await api.post("/delete_user", null, {
      params: { id },
    });
    invalidateLists("users:");
    return data;
  },

  /* ═══════════════════════════════════════════════
     KNOWLEDGE BASE (Bilgi Bankası)
     ═══════════════════════════════════════════════ */
  async getKnowledge() {
    const { data } = await api.get("/get_Information");
    return Array.isArray(data) ? data : [];
  },

  async addKnowledge({ title, description, image }) {
    const { data } = await api.post("/add_knowledge", {
      title,
      description,
      image,
    });
    return data;
  },

  async editKnowledge({ id, title, description, image }) {
    const { data } = await api.post("/edit_knowledge", {
      id,
      title,
      description,
      image,
    });
    return data;
  },

  async deleteKnowledge(id) {
    const { data } = await api.post("/delete_knowledge", null, {
      params: { id },
    });
    return data;
  },

  /* ═══════════════════════════════════════════════
     UPLOAD (Dosya Yükleme)
     ═══════════════════════════════════════════════ */
  async uploadFile(file, sunucuKodu = "BilgiBankasi", dosyaType = "image") {
    const formData = new FormData();
    formData.append("myfile", file);
    formData.append("sunucukodu", sunucuKodu);
    formData.append("dosyaType", dosyaType);
    const { data } = await api.post("/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 30000,
    });
    return data;
  },

  /* ═══════════════════════════════════════════════
     ORTAK (Bildirim Bayrağı)
     ═══════════════════════════════════════════════ */
  async changeUpdateValue({ target, newValue, userId, root = "support" }) {
    const { data } = await api.post("/change_status_update_value", {
      target,
      new_value: newValue,
      user_id: toNum(userId) ?? userId,
      root,
    });
    return data;
  },

  /* ═══════════════════════════════════════════════
   NOTIFICATIONS (Duyurular)
   ═══════════════════════════════════════════════ */
  async getNotifications({ sunucuKodu = "Hepsi", userType = "all" }) {
    const { data } = await api.post("/get_notification", {
      sunucuKodu,
      userType,
    });
    return Array.isArray(data) ? data : [];
  },

  async addNotification({ title, description, image, sunucuKodu, userType }) {
    const { data } = await api.post("/add_notification", {
      title,
      description,
      image,
      sunucu_kodu: sunucuKodu,
      user_type: userType,
    });
    return data;
  },

  async editNotification({
    id,
    title,
    description,
    image,
    sunucuKodu,
    userType,
  }) {
    const { data } = await api.post("/edit_notification", {
      id,
      title,
      description,
      image,
      sunucu_kodu: sunucuKodu,
      user_type: userType,
    });
    return data;
  },

  async deleteNotification(id) {
    const { data } = await api.post("/delete_notification", null, {
      params: { id },
    });
    return data;
  },
};
